<template>
  <div id="sign-up" class="container mt-5">
    <form @submit.prevent="signUp">
      <div class="form-group">
        <label for="email">Email Address:</label>
        <input
          v-model="emailInput"
          type="email"
          class="form-control"
          id="email"
          placeholder="Enter An Email"
        />
      </div>
      <div class="form-group">
        <label for="password">Password:</label>
        <input
          v-model="passwordInput"
          type="password"
          class="form-control"
          id="password"
          placeholder="Enter A Password"
        />
      </div>
      <button
        :disabled="!isFormValid"
        type="submit"
        class="btn btn-primary btn-block"
      >
        Sign Up
      </button>
      <p class="mt-1">
        Already have an account? <router-link to="/login">Sign In</router-link>.
      </p>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Register',
  data() {
    return {
      emailInput: '',
      passwordInput: ''
    }
  },
  methods: {
    signUp() {
      const { emailInput, passwordInput } = this

      firebase
        .auth()
        .createUserWithEmailAndPassword(emailInput, passwordInput)
        .then(
          () => {
            this.$router.go({ path: 'this.$router.path' })
          },
          err => {
            alert(err.message)
          }
        )
    }
  },
  computed: {
    isFormValid() {
      const { emailInput, passwordInput } = this

      return emailInput && passwordInput
    }
  }
}
</script>

<style lang="scss" scoped></style>
